import { H6 } from "src/components/HeadingV2/HeadingV2.tsx";
import { Flex } from "src/components/Flex.tsx";
import React from "react";

import { PanelField } from "src/components/Form/panels/DefaultFormPanel/PanelField.tsx";

export const GroupField = ({
  name,
}: {
  name: {
    title: string;
    fields_order: readonly (string | readonly string[])[];
  };
}) => {
  return (
    <Flex flexDirection="column">
      <H6>{name.title}</H6>
      <Flex gap={15} flexDirection="column">
        {name.fields_order.map((name, index) => {
          const key = typeof name === "string" ? name : JSON.stringify(name);
          return <PanelField name={name} key={key} />;
        })}
      </Flex>
    </Flex>
  );
};
